import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsGroupByExpand extends Layout {
    sourceCollections: DataSource;
    tableGroupByExpand: Table;
}
